export { default } from './AlertTable';
